<section class="realty container">
  <p class="title">
    <ng-container *ngIf="data.property_type && !data.property_sub_type">
      {{data.property_type | titlecase}}
    </ng-container>
    <ng-container *ngIf="data.property_type && data.property_sub_type">
      {{data.property_type | titlecase}}/{{data.property_sub_type | lowercase}}
    </ng-container>
    <ng-container *ngIf="data.property_utilization">
      - {{data.property_utilization | lowercase}}
    </ng-container>
    (Ref {{sku}})
  </p>
  <p class="title">
    <ng-container *ngIf="data.name">
      {{data.name}},
    </ng-container>
    <ng-container *ngIf="data.tower && data.tower != '0'">
      <span>Torre: </span>{{data.tower}},
    </ng-container>
    <ng-container *ngIf="data.floor_number">
      <span>Andar: </span>{{data.floor_number}},
    </ng-container>
    <ng-container *ngIf="data.unity_number">
      <span>Unidade: </span>{{data.unity_number}}
    </ng-container>
  </p>
  <p class="address" *ngIf="data.address">
    {{data.address.street_type}} {{data.address.street}},
    {{data.address.number}}, {{data.address.neighborhood}},
    {{data.address.city}}-SP,
    CEP: {{data.address.zip_code | mask:'00000-000'}}
  </p>
</section>

<section class="sale-value container" *ngIf="data.rent_value && condition === 'Pronto'">

  <p id="product-rent-value-title" class="title">Aluguel</p>

  <p class="value">
    R$ {{data.rent_value.value + data.condominium_fee.value + data.iptu_fee.value | number}}
    <span>total/mês</span>
  </p>

  <p class="description">
    <span><strong>Aluguel</strong> R$ {{data.rent_value.value | number}}</span>
    <span *ngIf="data.condominium_fee.value"><strong>Condominio</strong> R$
      {{data.condominium_fee.value | number}}</span>
    <span><strong>IPTU</strong> R$ {{data.iptu_fee.value | number}}</span>
  </p>

</section>

<section class="sale-value container" *ngIf="data.sale_value && condition === 'Pronto'">

  <p id="product-sale-value-title" class="title">Compra</p>

  <p class="value">
    {{data.sale_value.currency}} {{data.sale_value.value | number}}
  </p>

  <p class="description">
    <span *ngIf="data.condominium_fee"><strong>Condominio</strong> R$ {{data.condominium_fee.value | number}}</span>
    <span *ngIf="data.iptu_fee"><strong>IPTU</strong> R$ {{data.iptu_fee.value | number}}</span>
  </p>

  <a id="simulate-value" target="_blank"
    href="https://www.lopes.com.br/calculadora-simulador-de-financiamento-imobiliario">
    Simular valor financiado
  </a>

</section>

<ul class="details container">
  <ng-container *ngFor="let item of data.product_values">
    <ng-container
      *ngIf="data.condition !== 'lançamento' || (data.condition === 'lançamento' && item.type !== 'living_area')">
      <ng-container *ngIf="(item.value != data.condition && item.value != '0' && item.value != '0.0')">
        <li class="item" id="{{item.type}}_detail">
          <figure>
            <img [alt]="item.name" src="/assets/svgs/product-details/red/{{item.type}}.svg"
              onerror="this.src='/assets/svgs/product-details/red/default.svg'">
            <figcaption>
              {{item.name}}
              <ng-container *ngIf="data.condition !== 'lançamento' && item.type === 'total_area'">total</ng-container>
            </figcaption>
          </figure>
          <span>
            {{item.value}}
            <ng-container *ngIf="item.type === 'area' || item.type === 'total_area' || item.type === 'living_area'">m²
            </ng-container>
          </span>
        </li>
      </ng-container>
    </ng-container>
  </ng-container>
</ul>

<section class="about container" *ngIf="data.property_description">

  <h4>Sobre o imóvel</h4>

  <div [innerHTML]="data.property_description" class="description hideable" id="realty-description"
    [class.hide]="hideDescription === true">
  </div>

  <a id="show-realty-description" (click)="hideDescription = !hideDescription">Ver menos</a>

</section>